import { Auth } from 'aws-amplify';

import { isJSON } from 'utils/json';
import { forceLoginRedirect } from 'utils/forceLoginRedirect';

const IS_SERVER = typeof window === 'undefined';

export const configureAxiosWithToken = (axiosWithToken) => {
  configureAxios(axiosWithToken);

  axiosWithToken.interceptors.request.use(configCallBack);
};

export const configureAxios = (axios) => {
  axios.interceptors.response.use(responseCallback, errorCallback);
};

const responseCallback = (response) => {
  if (response.data.errorMessage) {
    return Promise.reject(new Error(response.data.errorMessage));
  }

  if (response && response.data.statusCode === 401) {
    forceLoginRedirect();
  }

  if (response.data.statusCode === 400) {
    return Promise.reject(new Error(response.data.body));
  }

  return response;
};

const errorCallback = async (error) => {
  const { response } = error;

  if (
    response
    && response.status === 400
    && response.data?.errors
    && !isJSON(response.data.errors[0])
  ) {
    const error = response.data.errors[0];

    if (error.message) {
      return Promise.reject(new Error(error.message));
    }
  }

  if (response?.status === 401 || response?.status === 403) {
    forceLoginRedirect();
  }

  return Promise.reject(error);
};

const configCallBack = (config) => {
  if (!IS_SERVER) {
    return new Promise((resolve) => {
      Auth.currentSession()
        .then((session) => {
          const accessTokenExpire = session.getAccessToken().getExpiration();
          const refreshToken = session.getRefreshToken();
          const currentTimeSeconds = Math.round(+new Date() / 1000);

          if (accessTokenExpire < currentTimeSeconds) {
            Auth.currentAuthenticatedUser().then((res) => {
              res.refreshSession(refreshToken, (err, data) => {
                if (err) {
                  Auth.signOut();
                } else {
                  config.headers.common.authToken = data.getAccessToken().getJwtToken();

                  resolve(config);
                }
              });
            });
          } else {
            config.headers.common.authToken = session.getAccessToken().getJwtToken();

            resolve(config);
          }
        })
        .catch(() => {
          resolve(config);
        });
    });
  }

  return null;
};
